/*
 * @Author: cc
 * @Date: 2021-01-14 17:23:53
 * @LastEditTime: 2022-03-16 10:36:28
 * @LastEditors: Please set LastEditors
 * @FilePath: \MCN_new\app\main\submissionManage\personalLibrary\manuscriptDetails\manuscriptDetails.js
 * @Description: 首页
 */
'use strict';
angular.module('manuscriptDetailsModule', ['manuscriptDetailsRouter']).controller('manuscriptDetailsCtrl', [
    '$scope',
    'httpService',
    '$state',
    '$stateParams',
    '$sce',
    'ueditorService',
    'persinalLibraryService',
    function ($scope, httpService, $state, $stateParams, $sce, ueditorService, persinalLibraryService) {
        initStatus();
        initData();
        /**
         * [initStatus description] 初始化参数
         */
        function initStatus() {
            $scope.status = {
                platform: $stateParams.platform
            };
            $scope.listData = [];
            $scope.page = {
                CURRPAGE: 0,
                PAGESIZE: 10,
                ITEMCOUNT: 0
            };
            $scope.params = {
                id: $stateParams.id
            };
        }
        /**
         * [initStatus description] 初始化数据
         */
        function initData() {
            requestData();
        }
        /**
         * [requestData description] 初始化列表数据
         */
        function requestData() {
            $scope.loadingPromise = httpService.http('/mcnww/web/article/findById.do', $scope.params, 'get').then(function (data) {
                $scope.listData = data;
                $scope.isRejection = $scope.listData.data.articleStatus===1&&$scope.listData.data.articleUseStatus===2;
                $scope.listData.htmlContent = $sce.trustAsHtml(data.data.articleHtmlCon);
                if (data.videoUrlList && data.videoUrlList.length) {
                    persinalLibraryService.getVideoDetail(data.videoUrlList[0].id).then(
                        (res) => {
                            $scope.status.videoUrl = res || data.videoUrlList[0].url;
                        }
                    );
                    if ($scope.status.videoUrl && $scope.status.videoUrl.split('?').length) {
                        $scope.status.videoUrl = $scope.status.videoUrl.split('?')[0];
                    }
                }
                ueditorService.drawVideoMark(false, true);
            });
        }
        $scope.toDetail = function (item) {
            var url = $state.href('editpage', { id: item.id, type: 6 }, { reload: 'editpage' });
            if (item.articleType === 2) {
                url = $state.href('editvideo', { id: item.id, type: 7 }, { reload: 'editvideo' });
            }
            if (item.articleType === 3) {
                url = $state.href('editPic', { id: item.id, type: 6 }, { reload: 'editPic' });
            }
            window.open(url, '_blank');
        };
    }
]);
